import { OrganizationAccessLevel, type User } from "@overmap-ai/common"
import { selectActiveOrganizationAccess } from "@overmap-ai/core"
import { useMemo } from "react"

import { useAppSelector } from "../store"

export const useUserOrganizationAccess = (accessLevel: OrganizationAccessLevel) => {
	const activeProjectAccess = useAppSelector(selectActiveOrganizationAccess)
	return activeProjectAccess ? activeProjectAccess.access_level >= accessLevel : false
}

export const useAssignees = (users: User[]) => {
	return useMemo(() => [...users, null], [users])
}
